import "../../common/polyfills.ts";
import api from "./api/index.ts";
import * as common from "../../common/constants.ts";
import * as core from "./core/index.ts";
import * as db from "./db/index.ts";
import * as util from "./util/index.ts";
import type { Conditions } from "../../common/types.ts";

self.bbgm = { api, ...common, ...core, ...db, ...util };

if (process.env.NODE_ENV === "development") {
	import("./core/debug/index.ts").then(({ default: debug }) => {
		self.bbgm.debug = debug;
	});
}

export type { WorkerAPICategory } from "../../common/types/workerApi.ts";

// API functions should have at most 2 arguments. First argument is passed here from toWorker. If you need to pass multiple variables, use an object/array. Second argument is Conditions.

type WorkerAPI = typeof api;
type WorkerAPIHandler = (param: unknown, conditions: Conditions) => unknown;

const hasApiCategory = (type: unknown): type is keyof WorkerAPI =>
	typeof type === "string" && Object.hasOwn(api, type);

const hasApiHandler = <Type extends keyof WorkerAPI>(
	type: Type,
	name: unknown,
): name is keyof WorkerAPI[Type] =>
	typeof name === "string" && Object.hasOwn(api[type], name);

const invokeApiHandler = <Type extends keyof WorkerAPI>(
	type: Type,
	name: keyof WorkerAPI[Type],
	param: unknown,
	conditions: Conditions,
) => {
	const handler = api[type][name] as unknown as WorkerAPIHandler;
	return handler(param, conditions);
};

(async () => {
	util.promiseWorker.register(([type, name, param], hostID) => {
		const conditions: Conditions = {
			hostID,
		};

		if (!hasApiCategory(type) || !hasApiHandler(type, name)) {
			throw new Error(
				`API call to nonexistant worker function "${type}.${name}"`,
			);
		}

		return invokeApiHandler(type, name, param, conditions);
	});
})();
